import { makeStyles } from 'tss-react/mui';

interface payload {
    type: 'sm' | 'md' | 'lg';
    flagNoPadding: boolean;
    flagVisible: boolean;
}

export const GlobalDialogBoxStyles = makeStyles<payload>()((theme, payload) => ({
    mainOuterDialogBoxContainer: {
        "& .MuiPaper-root": {
            padding: payload.flagNoPadding ? '0px' : '30px',
            borderRadius: '15px',
            height: payload.type === 'lg' ? '850px' : 'auto',
            width:
                payload.type === 'lg' ? '1400px' :
                    payload.type === 'md' ? '1200px' : '768px',
            maxWidth: 'unset',
            margin: '16px',
            visibility: payload.flagVisible ? 'visible' : 'hidden'
        },
        '@media (max-width: 720px)': {
            "& .MuiPaper-root": {
                padding: payload.flagNoPadding ? '0px' : '15px',
            }
        },
    },

    normalBtn: {
        background: '#3EAE54 !important',
        outline: "none",
        border: "none",
        fontSize: "14px",
        textTransform: 'none',
        color: '#fff !important',
        borderRadius: '5px',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 40px !important',
        '&:disabled': {
            opacity: '0.5 !important',
        },
    },

    newLogoStyles: {
        width: "44px",
        height: "44px",
        margin: '0 15px',
        borderRadius: "50%",
        "@media screen and (max-width:750px)": {
            width: "35px !important",
            height: "35px !important",
            marginRight: "15px !important",
            display: "block"
        },
    },

    paraMainTextHeader: {
        fontSize: "15px",
        fontWeight: "600",
        marginTop: "10px",
        color: '#000'
    },

    mainTitleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: '0px',
        lineHeight: 'inherit',
        maxWidth: "100%",
        background: "#E4E4E4",
        padding: "5px",
        borderRadius: "15px",
        borderTopLeftRadius: "0",
        minHeight: "70px",
        fontSize: "20px",
        textAlign: "left",
    },

    mainTitleText: {
        // display: 'contents',
        fontSize: '20px',
        color: "#3B78CE",
        fontWeight: 700,
        lineHeight: '1',
        '@media (max-width: 500px)': {
            fontSize: '16px',
        },
        '@media (max-width: 350px)': {
            fontSize: '14px',
        }
    },

    textBoxContainer: {
        marginBlockStart: "10px",
        backgroundColor: "#E4E4E4",
        borderRadius: '15px',
        padding: '15px 24px ',
    },

    invisibleSpace: {
        minHeight: '0.1px',
        marginBottom: '10px'
    },

    buttonContainer: {
        justifyContent: "center",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        '@media (max-width: 500px)': {
            flexDirection: "column",
        },
    },
}));